export const DEFAULT_COSMOS_ALLOWED_EMAILS = [
  "alice.bracchi@aihr.com",
  "marion.frecaut@aihr.com",
  "aliia.ioanu@aihr.com",
  "andressa.machado@aihr.com",
  "igor.klimenko@aihr.com",
  "karahan.ozen@aihr.com",
  "moien.tajik@aihr.com",
  "tetiana.sierikova@aihr.com",
  "gustavo.coelho@aihr.com",
  "filippos.koulyras@aihr.com"
] as const;

export const normalizeCosmosEmail = (email?: string | null): string | undefined => {
  const normalized = email?.trim().toLowerCase();
  return normalized && normalized.length > 0 ? normalized : undefined;
};

export const isAllowedCosmosEmail = (email?: string | null): boolean => {
  const normalized = normalizeCosmosEmail(email);
  if (!normalized) {
    return false;
  }

  const raw = import.meta.env.VITE_COSMOS_ALLOWED_EMAILS as string | undefined;
  const allowed: readonly string[] = raw?.trim()
    ? raw
        .split(",")
        .map((entry) => entry.trim().toLowerCase())
        .filter(Boolean)
    : DEFAULT_COSMOS_ALLOWED_EMAILS;

  return allowed.includes(normalized);
};
